"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var alertModuleApi = _interopRequireWildcard(require("@/api/systemAlertModule"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      loading: false,
      visible: false,
      isEdit: false,
      pram: this.initParam(),
      adminList: [],
      rules: {
        moduleKey: [{
          required: true,
          message: '请填写模块KEY',
          trigger: 'blur'
        }],
        moduleName: [{
          required: true,
          message: '请填写模块名称',
          trigger: 'blur'
        }],
        enabled: [{
          required: true,
          message: '请选择启用状态',
          trigger: 'change'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.loadAdminList();
  },
  methods: {
    initParam: function initParam() {
      return {
        id: null,
        moduleKey: '',
        moduleName: '',
        packagePrefix: '',
        impactScope: '',
        devUserIds: [],
        testUserIds: [],
        enabled: 1
      };
    },
    loadAdminList: function loadAdminList() {
      var _this = this;
      return alertModuleApi.getAdminList().then(function (res) {
        _this.adminList = res || [];
      });
    },
    openInit: function () {
      var _openInit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(row) {
        var detail;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.pram = this.initParam();
              this.isEdit = !!row;
              if (!row) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return alertModuleApi.getAlertModuleDetail(row.id);
            case 1:
              detail = _context.v;
              this.pram.id = detail.id;
              this.pram.moduleKey = detail.moduleKey;
              this.pram.moduleName = detail.moduleName;
              this.pram.packagePrefix = detail.packagePrefix || '';
              this.pram.impactScope = detail.impactScope;
              this.pram.enabled = detail.enabled;
              // devUserIds / testUserIds 是逗号分隔字符串，转为数组
              this.pram.devUserIds = detail.devUserIds ? detail.devUserIds.split(',').map(Number).filter(Boolean) : [];
              this.pram.testUserIds = detail.testUserIds ? detail.testUserIds.split(',').map(Number).filter(Boolean) : [];
            case 2:
              this.visible = true;
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function openInit(_x) {
        return _openInit.apply(this, arguments);
      }
      return openInit;
    }(),
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    handerSubmit: function handerSubmit() {
      var _this2 = this;
      this.$refs['formRef'].validate(function (valid) {
        if (!valid) return;
        _this2.loading = true;
        var api = _this2.isEdit ? alertModuleApi.updateAlertModule : alertModuleApi.createAlertModule;
        api(_this2.pram).then(function () {
          _this2.$message.success(_this2.isEdit ? '编辑成功' : '新增成功');
          _this2.visible = false;
          _this2.loading = false;
          _this2.$emit('doRefresh');
        }).catch(function () {
          _this2.loading = false;
        });
      });
    }
  }
};